
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 mt-auto">
      <div className="max-w-screen-xl mx-auto p-4">
        <div className="flex items-center justify-center">
          <div className="flex flex-wrap items-center justify-center text-xs font-medium text-gray-500 dark:text-gray-400">
            <span className="mr-4 md:mr-6">
              © {currentYear} FeedXL Pty Ltd
            </span>
            <a href="/terms" target="_blank" rel="noopener noreferrer" className="underline underline-offset-4">Terms & Conditions</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
